module.exports = __webpack_public_path__ + "static/media/filter.d3d2e110.svg";